// extracted by mini-css-extract-plugin
export default {"vertical":"styles_vertical__P2Zio","horizontal":"styles_horizontal__ov0zb","btnHolder":"styles_btnHolder__O88g9"};